export default{
    room:'Room',
    roomTitle: 'Title',
    roomRecallNumber: 'Recall Number',
    roomStatus: 'Status',
    rooms:'Rooms',
    editRoom:'Edit Room',
    addRoom:'Add Room',
    unit : 'Search By Unit',
    doctor : 'doctor',
    triage : 'triage',
    roomType : 'roomType',


}